/*
 * window.cpPlay(el, name) — replays one of the event micro-interactions from
 * cp-theme.css (pop, bump, shake, shine) on an element.
 *
 * Removing and re-adding the class restarts the animation when the same
 * event fires twice in a row (two quick taps on "add"); the class is dropped
 * again on animationend so the element is left exactly as it was. With
 * prefers-reduced-motion the CSS has no animation, so the class is removed on
 * the next frame instead of waiting for an event that never comes.
 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  window.cpPlay = function (el, name) {
    if (!el) return;
    var cls = 'is-cp-' + name;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);

    if (reduce && reduce.matches) {
      requestAnimationFrame(function () { el.classList.remove(cls); });
      return;
    }

    var done = function (event) {
      if (event && event.target !== el && name !== 'shine') return;
      el.classList.remove(cls);
      el.removeEventListener('animationend', done);
    };
    el.addEventListener('animationend', done);
    // Safety net: an element hidden mid-animation never fires animationend.
    setTimeout(done, 1200);
  };
})();

/*
 * Scroll-in motion for cp-* sections (15.10.2026: "add animation where there
 * is none — it adds premium"). Two hooks, both one-shot:
 *
 *   [data-cp-inview]  gets .is-in once its top passes 88 % of the screen
 *                     height (a visibility ratio would never fire on a
 *                     page-tall block). The CSS of each section decides
 *                     what that means — usually its cards rising one after
 *                     another on a --i index.
 *   [data-cp-count]   counts up from 0 to its value (decimals from
 *                     data-cp-count-decimals), so "4.8" lands instead of
 *                     just sitting there.
 *
 * clean-reveal.js keeps the [data-reveal] vocabulary for single elements;
 * this is for groups. With reduced motion everything is shown at once.
 * window.cpInview(root) re-scans after content is injected (drawer, Section
 * Rendering API, infinite scroll).
 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function count(el) {
    var target = parseFloat(el.getAttribute('data-cp-count'));
    var decimals = parseInt(el.getAttribute('data-cp-count-decimals'), 10) || 0;
    if (isNaN(target) || reduce) return;
    var start = null;
    var dur = 900;
    var fmt = function (v) { return v.toFixed(decimals).replace('.', decimals ? '.' : ''); };
    el.textContent = fmt(0);
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      el.textContent = fmt(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = fmt(target);
    }
    requestAnimationFrame(step);
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          if (e.target.hasAttribute('data-cp-count')) count(e.target);
          else e.target.classList.add('is-in');
        });
      }, { threshold: 0, rootMargin: '0px 0px -12% 0px' })
    : null;

  window.cpInview = function (root) {
    (root || document).querySelectorAll('[data-cp-inview]:not(.is-in), [data-cp-count]:not([data-cp-counted])').forEach(function (el) {
      if (el.hasAttribute('data-cp-count')) el.setAttribute('data-cp-counted', '');
      if (!io || reduce) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.cpInview(); });
  else window.cpInview();
  document.addEventListener('shopify:section:load', function (e) { window.cpInview(e.target); });
})();

/*
 * Sideways rows inside a Lenis page ([data-cp-hscroll]: card photo swipe,
 * reviews row). A wheel gesture that is mostly sideways is stopped before it
 * reaches Lenis (which listens on window), so the row scrolls natively; a
 * mostly vertical one goes on to Lenis and scrolls the page. The old
 * data-lenis-prevent did the first half and broke the second — the page
 * would not scroll while the cursor sat on a card (Alik, 16.10.2026).
 */
document.addEventListener('wheel', function (event) {
  if (!event.target.closest || !event.target.closest('[data-cp-hscroll]')) return;
  if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) event.stopPropagation();
}, { passive: true });

/*
 * window.cpAdded(button, sizeLabel) — a size tapped on a product card.
 * The card's photo flies into the header cart icon, the icon bumps, and a
 * notice at the bottom says what was added with a "Кошик" button. The
 * drawer stays shut (cart-drawer.js skips source 'cp-card-size'), so the
 * customer keeps browsing (Alik, 16.10.2026).
 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var note = null;
  var hideTimer = null;

  function cartIcon() {
    var icons = document.querySelectorAll('cart-icon, .header-actions__cart-icon');
    for (var i = 0; i < icons.length; i++) {
      var r = icons[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return icons[i];
    }
    return null;
  }

  function fly(img, target) {
    if (reduce || !img || !target || !img.animate) return Promise.resolve();
    var from = img.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width) return Promise.resolve();
    var ghost = img.cloneNode();
    ghost.removeAttribute('srcset');
    ghost.src = img.currentSrc || img.src;
    ghost.className = 'cp-fly';
    ghost.style.cssText = 'position:fixed;z-index:2000;pointer-events:none;object-fit:cover;border-radius:8px;left:' + from.left + 'px;top:' + from.top + 'px;width:' + from.width + 'px;height:' + from.height + 'px;';
    document.body.appendChild(ghost);
    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);
    var s = Math.max(0.06, 28 / from.width);
    var anim = ghost.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '8px' },
      { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.55 - 60) + 'px) scale(' + (s + 0.35) + ')', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')', opacity: 0.2, borderRadius: '50%' }
    ], { duration: 720, easing: 'cubic-bezier(0.5, 0, 0.2, 1)' });
    return anim.finished.then(function () { ghost.remove(); }, function () { ghost.remove(); });
  }

  function notice(title, meta, thumb) {
    if (!note) {
      note = document.createElement('div');
      note.className = 'cp-added';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      document.body.appendChild(note);
      note.addEventListener('click', function (e) {
        if (e.target.closest('[data-cp-added-open]')) {
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          else window.location.href = '/cart';
          note.classList.remove('is-on');
        }
        if (e.target.closest('[data-cp-added-close]')) note.classList.remove('is-on');
      });
    }
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; };
    note.innerHTML =
      (thumb ? '<img class="cp-added__img" src="' + esc(thumb) + '" alt="">' : '') +
      '<span class="cp-added__text"><b>Додано в кошик</b><span>' + esc(title) + (meta ? ' · ' + esc(meta) : '') + '</span></span>' +
      '<button type="button" class="cp-added__open" data-cp-added-open>Кошик</button>' +
      '<button type="button" class="cp-added__close" data-cp-added-close aria-label="Закрити">×</button>';
    note.classList.remove('is-on');
    void note.offsetWidth;
    note.classList.add('is-on');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { note.classList.remove('is-on'); }, 4000);
  }

  function parts(button) {
    var card = button && button.closest('.minimal-card, .cp-upsell__card');
    return {
      card: card,
      img: card && card.querySelector('.minimal-card-link img, .cp-upsell__media img'),
      title: card ? (card.dataset.cpTitle || (card.querySelector('.minimal-card-title, .cp-upsell__name') || {}).textContent || '') : ''
    };
  }

  window.cpFly = function (button) {
    var target = cartIcon();
    fly(parts(button).img, target).then(function () {
      if (target && window.cpPlay) window.cpPlay(target, 'bump');
    });
  };

  window.cpAdded = function (button, sizeLabel, flown) {
    var pp = parts(button);
    var img = pp.img;
    var title = pp.title;
    if (!flown) window.cpFly(button);
    notice(String(title).split(', ')[0].trim(), sizeLabel, img ? (img.currentSrc || img.src) : '');
  };
})();
